import React, { Component } from 'react';
import css from '../ProjectPage/ProjectPage.module.scss';
import Header from '../ProjectPage/Header';
import ProjectItem from '../ProjectItem.js';

import ImgB1 from './assets/b1.jpg';
import ImgB2 from './assets/b2.jpg';
import ImgB4 from './assets/b4.jpg';
import ImgB5 from './assets/b5.jpg';
import ImgB6 from './assets/b6.jpg';
import ImgB7 from './assets/b7.jpg';
import ImgB8 from './assets/b8.jpg';
import ImgB9 from './assets/b9.jpg';
import ImgB10 from './assets/b10.jpg';
import ImgSketches1 from './assets/sketch-app-1.jpg';
import ImgSketches2 from './assets/sketch-app-2.jpg';
import ImgSheltertech from '../assets/ShelterTech.png';
import ImgBeboStreaming from '../assets/BeboStreaming.jpg';

export default class BeboTournaments extends Component {

    render () {
        return (
          <div className={css.projectPage}>
            <Header
              title='Bebo Tournaments'
              year='2018 — 2019'
              position='Product Designer & Installation Design'
            />
            <div className={css.content}>
              <img src={ImgB1} alt='Bebo Tournaments App' />
              <div className={css.text}>
                <p>Esports is a billion dollar industry and has more viewership than US professional baseball, soccer, and hockey, yet less than 1% of video game players play in professional level tournaments.</p>
                <p>Bebo Tournaments brings the excitement of pro tournaments to every player. Compete, watch, and win in daily scrimmages and weekly tournaments, no matter your age or skill level.</p>
              </div>
              <img src={ImgB2} alt='Bebo Tournament Logos' />
              <div className={css.aspectRatio}>
                <iframe title='Bebo Tournaments Trailer' width="100%" height="100%" src="https://www.youtube.com/embed/ckUP1WvnXx4?controls=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
              <div className={css.text}>
                <p>Pro tournaments typically are played in closed events with a production team that controls graphics, scoring, and the broadcast. Our tournament software uses the game-activity driven graphics engine that we had been working on as part of our streaming software to automate tournament processes so anyone could participate in or run their own tournament with a few minutes of setup.</p>
                <p>We teamed up with organisations that were  running tournaments in the Fortnite community to get started and found that players of every level were excited with how easy it was to participate in our events and how great their streams looked while playing.</p>
              </div>
              <img src={ImgB4} alt='Bebo Tournament Viewer' />
              <img src={ImgB5} alt='Bebo Tournament Overlay Graphics' />
              <div className={css.text}>
                <p>As we expanded to include a player base beyond competitive and pro-level players, Bebo Tournaments experimented with bringing pro esports teams to city leagues for high school and younger players, similar to the way Little League Baseball lets young baseball players play as their favourite professional teams.</p>
              </div>
              <img src={ImgB6} alt='Bebo eSports Team Page' />
              <img src={ImgB7} alt='Bebo eSports Concept' />
              <div className={css.text}>
                <p>My role on the project varies based on the needs of the team from sprint to sprint. Some weeks I’m delivering visual assets for the app or web interfaces of the product, other weeks I’m creating shareable graphics or art directing with contract designers to support a branded tournament, and in others I’m actively pushing code to improve the user experience.</p>
                <p>Due to the experimental nature of new products, my function aligns with the greatest needs of our team at the moment and I’m happy to join in wherever I’m needed, whether that’s pushing pixels, chatting with users, or writing css.</p>
              </div>
              <img src={ImgSketches1} alt='App Sketches' />
              <img src={ImgSketches2} alt='App Sketches' />
              <div className={css.text}>
                <p>The inaugural tournament season started at TwitchCon 2018. Pro players were invited to play against their fans in 30 minute micro-tournaments throughout the entire three day event. Designing the booth layout and graphics was my responsibility. The booth was one of the busiest of the entire exhibition and generated thousands of signups.</p>
              </div>
              <img src={ImgB8} alt='TwitchCon Booth with NateHill' />
              <img src={ImgB9} alt='TwitchCon Booth' />
              <img src={ImgB10} alt='TwitchCon Booth with Sceptic' />
              <div className={css.text}>
                <p>Want to know more about the design process for this project? <a href="https://docs.google.com/presentation/d/e/2PACX-1vQd6oWyUnV01NdHyB6tN2WMrHccQ0TSGLfRbS1oSdV37Dm7YQMq9GLm0vnw7oudjdRHcpdtOC-yAkdu/pub?start=false&loop=false&delayms=10000" target="_blank" rel="noopener noreferrer">View the case study here.</a></p>
              </div>
            </div>
            <div className={css.moreWork}>
              <header>More Projects</header>
                <ul className={css.moreWorkList}>
                  <ProjectItem
                    title='Bebo Streaming Software'
                    description='Next gen streaming software'
                    position='Product Designer / Apparel Design'
                    img={ImgBeboStreaming}
                    link='BeboStreaming'
                  />
                  <ProjectItem
                    title='Sheltertech'
                    description='Solving the biggest tech challenges faced by the homeless'
                    position='Co-Founder / Design & Product Lead'
                    img={ImgSheltertech}
                    link='Sheltertech'
                  />
                </ul>
            </div>
          </div>
        )
     }
  }
